import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAppData } from '../store';
import { CATEGORY_LABELS, CATEGORY_EMOJI, type PropertyCategory } from '../types';
import PropertyForm from './PropertyForm';

const CATEGORY_ORDER: PropertyCategory[] = ['property', 'vehicle', 'equipment', 'other'];

export default function PropertyList() {
  const { properties, obligations, loading } = useAppData();
  const [adding, setAdding] = useState(false);
  const navigate = useNavigate();

  if (loading) return <div className="loading-screen">Loading…</div>;

  const byCategory = CATEGORY_ORDER.map((category) => ({
    category,
    properties: properties.filter((p) => p.category === category),
  })).filter((g) => g.properties.length > 0);

  return (
    <div className="property-list">
      <div className="page-header">
        <h1>Properties</h1>
        <button className="btn-primary" onClick={() => setAdding(true)}>
          + Add property
        </button>
      </div>

      {adding && (
        <PropertyForm
          onCancel={() => setAdding(false)}
          onDone={(property) => {
            setAdding(false);
            navigate(`/properties/${property.id}`);
          }}
        />
      )}

      {properties.length === 0 && !adding && (
        <p className="muted empty">
          No properties yet. Add 253 or 255 Town Farm Hill, or anything else worth tracking.
        </p>
      )}

      {byCategory.map(({ category, properties: group }) => (
        <section key={category} className="property-category">
          <h2>
            {CATEGORY_EMOJI[category]} {CATEGORY_LABELS[category]}
          </h2>
          <div className="card-list">
            {group.map((property) => {
              const count = obligations.filter(
                (o) => o.property_id === property.id && o.active
              ).length;
              return (
                <Link key={property.id} to={`/properties/${property.id}`} className="card property-tile">
                  {property.photo_url ? (
                    <img className="property-tile-icon" src={property.photo_url} alt="" />
                  ) : (
                    <span className="property-tile-icon property-tile-icon-emoji">
                      {CATEGORY_EMOJI[property.category]}
                    </span>
                  )}
                  <div className="property-tile-main">
                    <div className="property-tile-title">{property.name}</div>
                    <div className="muted">
                      {property.llc_name ? `${property.llc_name} · ` : ''}
                      {count} obligation{count === 1 ? '' : 's'}
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </section>
      ))}
    </div>
  );
}
